<template>
    <h-captcha :site-key="siteKey"
               size="invisible"
               @loaded="onCaptchaLoaded"
               @verified="onCaptchaVerified"></h-captcha>
    <input type="hidden" name="d" :value="captcha">
    <div class="input-group " v-bind:class="{ 'has-validation': error }">

        <input id="email" v-model="email" type="email" name="email" class="form-control" placeholder="E-Mail-Adresse" v-bind:class="{ 'is-invalid': error }">
        <div v-if="error" class="invalid-feedback">
            {{errorMessage}}
        </div>
        <button class="btn btn-primary" type="submit" id="button-addon2" @click="captcha">Absenden</button>

    </div>
    <mail-check
        model-name="email"
        :data="email"
        :domains="['schule.hessen.de','gmail.com','gmail.de','googlemail.com','web.de','email.de','flirt.ms','hallo.ms','kuss.ms','love.ms','magic.ms','singles.ms','cool.ms','kanzler.ms','okay.ms','party.ms','pop.ms','stars.ms','techno.ms','clever.ms','deutschland.ms','genial.ms','ich.ms','online.ms','smart.ms','wichtig.ms','action.ms','fussball.ms','joker.ms','planet.ms','power.ms','gmx.de','gmx.net','mein.gmx','gmx.ch','gmx.at','email.gmx','gmx.biz','gmx.com','gmx.eu','gmx.info','gmx.org','mail.gmx','yahoo.de','yahoo.com','ymail.com','rocketmail.com','outlook.com','hotmail.de','hotmail.com','live.de','live.com','posteo.af','posteo.at','posteo.be','posteo.ca','posteo.ch','posteo.cl','posteo.co','posteo.co.uk','posteo.com.br','posteo.cr','posteo.cz','posteo.de','posteo.dk','posteo.ee','posteo.es','posteo.eu','posteo.fi','posteo.gl','posteo.gr','posteo.hn','posteo.hr','posteo.hu','posteo.ie','posteo.in','posteo.is','posteo.it','posteo.jp','posteo.la','posteo.li','posteo.lt','posteo.lu','posteo.me','posteo.mx','posteo.my','posteo.net','posteo.nl','posteo.no','posteo.nz','posteo.org','posteo.pe','posteo.pl','posteo.pm','posteo.pt','posteo.ro','posteo.ru','posteo.se','posteo.sg','posteo.si','posteo.tn','posteo.uk','posteo.us','t-online.de','magenta.de','jugendpresse.de','bvj.de','youmecon.de','schuelerzeitung.de','politikorange.de']"
        :topLevelDomains="['com', 'net', 'org','de','cloud']"
        :secondLevelDomains="['hotmail','mail','gmx','web','yahoo','hessen','schule','live']"

    >
        <span>Meintest du </span>
    </mail-check>
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
        <a class="modal__close" @click="showModal = false">
            <i class="fas fa-times"></i>
        </a>
        <span class="modal__title">Eine E-Mail ist unterwegs</span>
        <div class="modal__content">
            <p class="lead mb-4">Wir haben einen Bestätigungslink an <strong v-if="email">{{email}}</strong> gesendet. Bitte klicke den Link an. Dann geht es weiter mit dem Fragebogen.</p>
            <div v-if="webmail" class=" mb-4 d-grid gap-2 d-sm-flex justify-content-sm-center">
                <a :href="webmail.provider.url" target="_blank" class="btn btn-primary btn-lg px-4 gap-3"> {{webmail.provider.name}} öffnen</a>
            </div>

            <p class="lead mb-4">Die E-Mail kann bis zu fünf Minuten unterwegs sein. Bitte kontrolliere auch deinen Spam-Ordner. Der Bestätigungslink ist 24 Stunden gültig, aber du kannst jederzeit einen Neuen anfordern. </p>

        </div>
    </vue-final-modal>
</template>

<script>
import 'vanilla-hcaptcha';
export default {
    props: {
        slug:  {
            type: String,
            required: true
        },
        siteKey:  {
            type: String,
            required: true
        },
        value:  {
            type: String,
            required: false
        },
        error:  {
        type: Boolean,
        required: false
        },
        errorMessage: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            email: "",
            webmail:null,
            showModal:false
        }
    },
    methods: {
        captcha(e){
            hcaptcha.execute();
            e.preventDefault();
        },
        onCaptchaLoaded(e) {
        },
        onCaptchaVerified(e) {
            axios.post('/api/competition/login', {
                email: this.email,
                competition:this.slug,
                'h-captcha-response': e.key
            })
                .then((response) =>  {
                    console.log(response);
                    this.webmail=response.data.webmail;
                    this.showModal = true;

                })
                ;
        }
    },
}
</script>
<style scoped>
::v-deep .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90%;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
    max-width:750px ;
}
.modal__title {
    margin: 0 2rem 0.5rem 0;
    font-size: 1.5rem;
    font-weight: 700;
}
.modal__content {
    flex-grow: 1;
    overflow-y: auto;
}
.modal__action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem 0 0;
}
.modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
    border-color: #2d3748;
    background-color: #1a202c;
}
</style>

